<template>
    <div class="loginFormInner">
        <div class="loginForm">
            <h2>pochi</h2>
            <template v-if="step === 'password'">
            <div class="loginLine">
                <transition name="fade">
                    <div class="errorBalloon" v-if="!$v.email.email">
                        <p v-if="!$v.email.email">メールアドレスが正しい形式ではありません</p>
                    </div>
                </transition>
                <input class="loginInputText" :class="status($v.email)" type="email" placeholder="メールアドレス"
                    v-model.lazy="$v.email.$model" @keydown="enterSearch">
            </div>
            <div class="loginLine">
                <!-- <transition name="fade">
                <div class="errorBalloon" v-if="!$v.password.minLength || !$v.password.maxLength || !$v.password.alphaNum">
                    <p v-if="!$v.password.minLength || !$v.password.maxLength">・パスワードは{{ $v.password.$params.minLength.min }}文字以上{{ $v.password.$params.maxLength.max }}文字以内で入力してください</p>
                    <p v-if="!$v.password.alphaNum">・英数字以外の文字は入力できません</p>
                </div>
            </transition> -->
                <input class="loginInputText" type="password" placeholder="パスワード" v-model.lazy="$v.password.$model"
                    @keydown="enterSearch">
                <!-- <input class="loginInputText" :class="status($v.password)" type="password" placeholder="パスワード" v-model.lazy="$v.password.$model" @keydown="enterSearch"> -->
            </div>
            </template>
            <template v-else-if="step === 'otp'">
                <h3>二段階認証</h3>
                <p class="twoFactorLead">認証アプリに表示されている6桁のコードを入力してください</p>
                <div class="loginLine">
                    <input ref="otp" class="loginInputText" type="text" inputmode="numeric" autocomplete="one-time-code"
                        maxlength="6" placeholder="認証コード（6桁）" v-model.trim="otp" @keydown.enter="submitOtp">
                </div>
            </template>
            <template v-else>
                <h3>二段階認証の設定</h3>
                <ol class="twoFactorSteps">
                    <li>認証アプリで下のQRコードを読み取ってください</li>
                    <li>アプリに表示された6桁のコードを入力してください</li>
                </ol>
                <div class="twoFactorQr">
                    <img :src="'data:image/svg+xml;base64,' + qrSvgBase64" alt="二段階認証用QRコード">
                </div>
                <div class="loginLine twoFactorSecretLine">
                    <p class="twoFactorSecretLabel">読み取れない場合は、次のキーを入力してください</p>
                    <code class="twoFactorSecret">{{ formattedSecret }}</code>
                </div>
                <div class="loginLine">
                    <input ref="setupOtp" class="loginInputText" type="text" inputmode="numeric"
                        autocomplete="one-time-code" maxlength="6" placeholder="認証コード（6桁）" v-model.trim="otp"
                        @keydown.enter="confirmTwoFactor">
                </div>
            </template>
            <div class="loginLine">
                <div class="loginAction">
                    <transition name="fade">
                        <div class="errorBalloon" v-if="loginErrorMessage">
                            <p>{{ loginErrorMessage }}</p>
                            <p v-if="isTwoFactorSetupRequired">
                                <a :href="$helpers.am_url()" target="_blank" rel="noopener">アムを開く</a>
                            </p>
                        </div>
                    </transition>
                    <a class="btn" v-if="step === 'setup'" @click="confirmTwoFactor">登録してログイン</a>
                    <a class="btn" v-else-if="step === 'otp'" @click="submitOtp">ログイン</a>
                    <a class="btn" v-else @click="login">ログイン</a>
                </div>
            </div>
            <div class="loginLine loginAction" v-if="step !== 'password'">
                <a class="backToLogin" href="#" @click.prevent="backToPassword">ログイン画面に戻る</a>
            </div>
        </div>
    </div>
</template>

<script>
import { email, alphaNum, minLength, maxLength } from "vuelidate/lib/validators"

// AM の二段階認証で返ってくる error ごとの案内文
const TWO_FACTOR_ERROR_MESSAGES = {
    otp_required: "認証アプリに表示されている6桁のコードを入力してください",
    otp_format: "認証コードは6桁の数字で入力してください",
    // 同じコードは2回使えないので、アムにログインした直後は次のコードを待ってもらう
    otp_invalid: "認証コードが正しくありません。少し待って、次に表示されたコードを入力してください",
    otp_locked: "認証コードを続けて間違えたため、ログインできません。しばらく時間をおいてから再度お試しください",
    two_factor_setup_required: "先にアムで二段階認証を設定してください",
    too_many_attempts: "ログインの試行回数が多すぎます。1分ほど待ってから再度お試しください",
    two_factor_enrollment_closed: "二段階認証の登録受付期間が終わっています。管理者に登録許可を依頼してください",
    setup_token_invalid: "登録の有効期限が切れました。もう一度ログインからやり直してください",
    two_factor_already_confirmed: "二段階認証はすでに設定済みです。認証コードを入力してログインしてください",
}

// 読んでもらう必要があるので、時間で自動的に消さない案内
const PERSISTENT_ERRORS = [
    "two_factor_setup_required",
    "otp_locked",
    "two_factor_enrollment_closed",
    "setup_token_invalid",
]

const OTP_PATTERN = /^\d{6}$/

export default {
    name: 'Login',
    data() {
        return {
            email: "",
            password: "",
            otp: "",
            loginError: null,
            loginErrorTimer: null,
            // 画面の段階: password（メール＋パスワード）→ otp（6桁）／ setup（二段階認証の QR 登録）
            step: "password",
            // ログイン・登録の二重送信を防ぐ（二重に送ると AM の登録用 token が入れ替わってしまう）
            isSubmitting: false,
            // 二段階認証の登録用（登録画面を抜けたら必ず消す）
            qrSvgBase64: "",
            secret: "",
        }
    },
    computed: {
        loginErrorMessage() {
            if (!this.loginError) return ""

            return TWO_FACTOR_ERROR_MESSAGES[this.loginError] ?? "ログインできません"
        },
        isTwoFactorSetupRequired() {
            return this.loginError === "two_factor_setup_required"
        },
        formattedSecret() {
            // 手入力しやすいように4文字ずつ区切る
            return this.secret.match(/.{1,4}/g)?.join(" ") ?? ""
        },
    },
    validations: {
        email: {
            email
        },
        password: {
            alphaNum,
            minLength: minLength(4),
            maxLength: maxLength(8),
        }
    },
    watch: {
        loginError(value) {
            // 前のエラーのタイマーで新しいエラーが消えないようにする
            clearTimeout(this.loginErrorTimer)

            if (!value || PERSISTENT_ERRORS.includes(value)) return

            this.loginErrorTimer = setTimeout(() => { this.loginError = null }, 5000)
        },
    },
    beforeDestroy() {
        clearTimeout(this.loginErrorTimer)
        if (this.step === "setup") this.cancelTwoFactorSetup()
        this.clearTwoFactorSetup()
    },
    created: function () {
        this.$store.dispatch('logined', false)
        this.$store.dispatch('userInfo', {})
    },
    methods: {
        async login() {
            if (this.isSubmitting) return
            this.isSubmitting = true
            this.loginError = null
            try {
                await this.axios.get("/sanctum/csrf-cookie", {
                    withCredentials: true
                })
                await this.axios.post("/api/login", {
                    email: this.email,
                    password: this.password,
                    otp: this.step === "otp" ? this.otp : "",
                })
                this.otp = ""
                this.onLoginSucceeded()
            } catch (error) {
                const loginError = this.errorCode(error)
                // 認証コードは時間で変わるので、失敗したら入れ直してもらう
                this.otp = ""
                if (loginError === "two_factor_setup_required") {
                    await this.startTwoFactorSetup()
                } else if (loginError === "otp_required") {
                    // パスワードは合っているので、6桁の入力に進む
                    this.showStep("otp")
                } else {
                    this.loginError = loginError
                    if (this.step === "otp") this.focusOtp()
                }
            } finally {
                this.isSubmitting = false
            }
        },
        submitOtp() {
            if (!OTP_PATTERN.test(this.otp)) {
                this.loginError = "otp_format"
                this.focusOtp()
                return
            }
            this.login()
        },
        onLoginSucceeded() {
            this.$store.dispatch('logined', true)
            this.$router.push("/home")
            this.checkAccess();
            this.checkAccessDev();
            this.defaultMenu();
        },
        // ログイン時にサーバーのセッションへ保存された登録用 token で QR を発行してもらう
        async startTwoFactorSetup() {
            try {
                const res = await this.axios.post("/api/two_factor/setup")
                this.qrSvgBase64 = res.data.qr_svg_base64
                this.secret = res.data.secret
                this.showStep("setup")
            } catch (error) {
                const setupError = this.errorCode(error)
                // 登録画面に入れなかったときは、アムで設定してもらう案内を予備として出す
                this.loginError = ["too_many_attempts", "setup_token_invalid", "two_factor_already_confirmed"].includes(setupError)
                    ? setupError
                    : "two_factor_setup_required"
            }
        },
        async confirmTwoFactor() {
            if (this.isSubmitting) return
            if (!OTP_PATTERN.test(this.otp)) {
                this.loginError = "otp_format"
                this.focusOtp()
                return
            }
            this.isSubmitting = true
            this.loginError = null
            try {
                await this.axios.post("/api/two_factor/confirm", {
                    otp: this.otp,
                })
                this.clearTwoFactorSetup()
                this.onLoginSucceeded()
            } catch (error) {
                const confirmError = this.errorCode(error)
                this.otp = ""
                if (["otp_invalid", "otp_locked", "too_many_attempts"].includes(confirmError)) {
                    this.focusOtp()
                } else if (confirmError === "two_factor_already_confirmed") {
                    // 登録は済んでいるので、6桁でのログインに進んでもらう
                    this.clearTwoFactorSetup()
                    this.showStep("otp")
                } else {
                    // 期限切れ・想定外のときは QR を残さず、ログインからやり直してもらう
                    this.clearTwoFactorSetup()
                    this.password = ""
                }
                this.loginError = confirmError
            } finally {
                this.isSubmitting = false
            }
        },
        backToPassword() {
            if (this.step === "setup") this.cancelTwoFactorSetup()
            this.clearTwoFactorSetup()
            this.loginError = null
        },
        // サーバーのセッションに残った登録待ち情報も消してもらう（共用 PC で次の人に続きをされないように）
        cancelTwoFactorSetup() {
            this.axios.post("/api/two_factor/cancel").catch(() => {})
        },
        clearTwoFactorSetup() {
            this.step = "password"
            this.qrSvgBase64 = ""
            this.secret = ""
            this.otp = ""
        },
        showStep(step) {
            this.step = step
            this.loginError = null
            this.focusOtp()
        },
        focusOtp() {
            this.$nextTick(() => {
                const input = this.step === "setup" ? this.$refs.setupOtp : this.$refs.otp
                if (input) input.focus()
            })
        },
        errorCode(error) {
            if (error.response?.status === 429) return "too_many_attempts"

            return error.response?.data?.error ?? "unknown"
        },
        status(validation) {
            return {
                error: validation.$error,
                dirty: validation.$dirty
            }
        },
        enterSearch: function (e) {
            if (e.keyCode == 13) {
                this.login();
            }
        },
        async checkAccess() {
            let url = '/api/checkAccess';
            try {
                let res = await this.axios.get(url);
                this.$store.dispatch("isAccessable", res.data)
            } catch (error) {
                console.error("Error in checkAccess_Header:", error);
                this.$store.dispatch("isAccessable", false)
            }
        },
        async checkAccessDev() {
            let url = '/api/checkAccessDev';
            try {
                let res = await this.axios.get(url);
                this.$store.dispatch("isAccessableDev", res.data)
            } catch (error) {
                console.error("Error in checkAccessDev_Header:", error);
                this.$store.dispatch("isAccessableDev", false)
            }
        },
        async defaultMenu() {
            this.axios.get("/api/roasDefaultMenu/")
                .then((res) => {
                    if (res.data != "") {
                        this.$store.dispatch("defaultMenu", res.data)
                    }
                    else {
                        this.$store.dispatch("defaultMenu", "site")
                    }
                });
        },
    }
}
</script>

<style scoped lang="sass">
.loginFormInner
    align-items: center
    display: flex
    justify-content: center
    height: calc(100% - 50px)
    position: absolute
    top: 50px
    width: 100%
.loginForm
    background: $whiteColor
    color: $grayColor
    font-size: 1.3rem
    text-align: center
    width: 400px
    h2
        color: $mainColor
        font-size: 2.5rem
        font-weight: 800
        margin: 20px 0 30px 0
    .loginLine
        margin: 0 auto 20px
        position: relative
        text-align: left
        width: 60%
        .errorBalloon
            left: 260px
            min-width: 380px
            padding: 10px
            position: absolute
            &:before
                border: 5px solid transparent
                border-right: 10px solid #FDD
                left: -15px
                margin-top: -12px
                position: absolute
                top: 20px
            &:after
                border: 7px solid transparent
                border-right: 12px solid #ff0000
                left: -19px
                margin-top: -14px
                position: absolute
                top: 20px
        .fade-enter-active, .fade-leave-active
            transition: opacity 1s
        .fade-enter, .fade-leave-to
            opacity: 0
        .loginInputText
            border: 1px solid $grayColor
            padding: 10px
            width: 100%
            &:focus
                outline: 2px solid $mainColor
    .loginAction
        text-align: center
    h3
        color: $mainColor
        font-size: 1.6rem
        font-weight: 700
        margin: 0 0 15px 0
    .twoFactorLead
        font-size: 1.1rem
        margin: 0 auto 15px
        width: 85%
    .twoFactorSteps
        margin: 0 auto 15px
        padding-left: 1.5em
        text-align: left
        width: 85%
    .twoFactorQr
        margin: 0 auto 15px
        text-align: center
        img
            height: 200px
            width: 200px
    // 説明文と手入力キー（4文字×8＋区切り）が1行に収まるよう、入力欄より広くする
    .loginLine.twoFactorSecretLine
        text-align: center
        width: 85%
    .twoFactorSecretLabel
        font-size: 1.1rem
        margin-bottom: 5px
    .twoFactorSecret
        display: block
        font-family: monospace
        font-size: 1.2rem
        text-align: center
        user-select: all
    .backToLogin
        font-size: 1.1rem
</style>
